import { useState } from 'react';
import { Button, Header, Modal } from 'semantic-ui-react';
import AddCredentials from './Credentials/AddCredentials';
import CredentialsDetails from './Credentials/CredentialDetails';

const ClientCredentials = ({ clientId: id, credentials }: any) => {
  const [showModal, setShowModal] = useState<string>(null);
  const [addModal, setAddModal] = useState<string>(null);
  const [editModal, setEditModal] = useState<string>(null);

  const handleEdit = () => {
    setEditModal(showModal);
    setShowModal(null);
  };

  return (
    <div>
      <Header>Credentials</Header>

      {!credentials ? (
        <AddCredentials clientId={id} />
      ) : (
        <div style={{ display: 'flex' }}>
          {Object.keys(credentials).map((elem: string) => {
            if (credentials[elem]) {
              return (
                <div
                  key={elem}
                  style={{ display: 'flex', flexDirection: 'column' }}
                >
                  <h4>{elem}</h4>
                  <Button size="small" onClick={() => setShowModal(elem)}>
                    View/Manage
                  </Button>
                </div>
              );
            } else {
              return (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <h4>{elem}</h4>
                  <Button size="small" onClick={() => setAddModal(elem)}>
                    Add Credentials
                  </Button>
                </div>
              );
            }
          })}
        </div>
      )}

      {showModal ? (
        <Modal
          open={showModal !== null}
          onClose={() => setShowModal(null)}
          size="fullscreen"
          closeIcon
        >
          <Modal.Header>Credentials</Modal.Header>
          <Modal.Content>
            <CredentialsDetails
              clientId={id}
              credentialType={showModal}
              onEdit={handleEdit}
            />
          </Modal.Content>
        </Modal>
      ) : null}
      {addModal ? (
        <Modal open={addModal !== null} onClose={() => setAddModal(null)}>
          <Modal.Header>Add Credentials</Modal.Header>
          <Modal.Content>
            <AddCredentials
              clientId={id}
              credentialType={addModal}
              onSubmit={() => setAddModal(null)}
            />
          </Modal.Content>
        </Modal>
      ) : null}
      {editModal ? (
        <Modal
          closeIcon
          open={editModal !== null}
          onClose={() => setEditModal(null)}
        >
          <Modal.Header>Edit Credentials</Modal.Header>
          <Modal.Content>
            <AddCredentials
              clientId={id}
              credentialType={editModal}
              credential={credentials[editModal]}
              onSubmit={() => setEditModal(null)}
            />
          </Modal.Content>
        </Modal>
      ) : null}
    </div>
  );
};

export default ClientCredentials;
